import React from 'react'
import { Grid, IconButton, Card} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import { useState } from 'react';
import ArgonButton from 'components/ArgonButton';
import MiniDialog from 'components/MiniDialog/MiniDialog';
import DeleteDialog from 'components/DeleteDialog/DeleteDialog';


function communication() {
 
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => setOpen(true);
   const handleClose = () => setOpen(false);

  //Add complaint k liey
    const [open1, setOpen1] = useState(false);
     const handleClickOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const complaints = [
    { text: "Class timing conflicts with other activities", date: "15-01-2024", status: "pending" },
    { text: "Tutor's teaching method needs improvement", date: "10-01-2024", status: "resolved" }
  ];
  
  const feedbacks = [
    { text: "Excellent teaching methods and clear explanations", date: "12-01-2024", rating: 5 },
    { text: "Need more interactive sessions and practice", date: "08-01-2024", rating: 4 }
  ];

// delete complaint
  const [deleteDialog, setDeleteDialog] = useState(false);
  const handleDeleteClick = () => {
    setDeleteDialog(true);
  };
  const handleDeleteClose = () => {
    setDeleteDialog(false);
  };

  // delete feedback
   const [deleteDialog1, setDeleteDialog1] = useState(false);
  const handleDeleteClick1 = () => {
    setDeleteDialog1(true);
  };
  const handleDeleteClose1 = () => {
    setDeleteDialog1(false);
  };

  return (
    <ArgonBox p={2}>
  {/* Compact Header */}
  <ArgonBox mb={4} mt={3} textAlign="center">
    <ArgonTypography variant="h5" fontWeight="bold" color="primary" mb={0.5}>
      💬 Communication Center
    </ArgonTypography>
    <ArgonTypography variant="body2" color="text" fontSize="0.875rem">
      Manage complaints and feedback efficiently
    </ArgonTypography>
  </ArgonBox>

  <Grid container spacing={2}>
    {/* Complaint Section */}
    <Grid item xs={12} lg={6}>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
          border: "1px solid #e0e0e0",
          overflow: "hidden",
          height: "fit-content",
          background: "#ffffff",
        }}
      >
        {/* Header */}
        <ArgonBox
          sx={{
            borderBottom: "1px solid #f0f0f0",
            p: 2,
            bgcolor: "white",
          }}
        >
          <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
            <ArgonBox display="flex" alignItems="center" gap={1.5}>
              <ArgonTypography variant="subtitle1" fontWeight="medium" color="text.primary">
                Complaint
              </ArgonTypography>
            </ArgonBox>
            <ArgonButton
              onClick={handleClickOpen}
              variant="contained"
              size="small"
              color="primary"
             
            >
              Add
            </ArgonButton>
          </ArgonBox>
        </ArgonBox>

        {/* Content */}
        <ArgonBox sx={{ p: 2 }}>
          {complaints.length === 0 ? (
            <ArgonBox textAlign="center" py={3}>
              <ArgonTypography variant="body2" color="text.secondary" fontSize="0.875rem">
                No complaints yet. Great job! 🎉
              </ArgonTypography>
            </ArgonBox>
          ) : (
            complaints.map((item, index) => (
              <Card
                key={index}
                sx={{
                  mb: 1.5,
                  p: 2,
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  background: "#fafafa",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-1px)",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                  },
                }}
              >
                <ArgonBox display="flex" justifyContent="space-between" alignItems="flex-start">
                  <ArgonBox flex={1}>
                    <ArgonTypography variant="body" fontWeight="medium" mb={1} fontSize="0.875rem">
                      {item.text}
                    </ArgonTypography>
                    
                  </ArgonBox>
                  <IconButton
                    size="small"
                    sx={{
                      color: "error.main",
                      ml: 1,
                      "&:hover": {
                        backgroundColor: "rgba(244, 67, 54, 0.1)",
                      },
                    }}
                  >
                    <DeleteIcon onClick={handleDeleteClick} fontSize="small" />
                  </IconButton>
                </ArgonBox>
              </Card>
            ))
          )}
        </ArgonBox>
      </Card>
    </Grid>

    {/* Feedback Section */}
    <Grid item xs={12} lg={6}>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
          border: "1px solid #e0e0e0",
          overflow: "hidden",
          height: "fit-content",
          background: "#ffffff",
        }}
      >
        {/* Header */}
        <ArgonBox
          sx={{
            borderBottom: "1px solid #f0f0f0",
            p: 2,
            bgcolor: "white",
          }}
        >
          <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
            <ArgonBox display="flex" alignItems="center" gap={1.5}>
              <ArgonTypography variant="subtitle1" fontWeight="medium" color="text.primary">
                Feedback
              </ArgonTypography>
            </ArgonBox>
            <ArgonButton
              onClick={handleClickOpen1}
              variant="contained"
              size="small"
              color="primary"
            >
              Add
            </ArgonButton>
          </ArgonBox>
        </ArgonBox>

        {/* Content */}
        <ArgonBox sx={{ p: 2 }}>
          {feedbacks.length === 0 ? (
            <ArgonBox textAlign="center" py={3}>
              <ArgonTypography variant="body2" color="text.secondary" fontSize="0.875rem">
                No feedback yet. Share your thoughts! ✨
              </ArgonTypography>
            </ArgonBox>
          ) : (
            feedbacks.map((item, index) => (
              <Card
                key={index}
                sx={{
                  mb: 1.5,
                  p: 2,
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  background: "#fafafa",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-1px)",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                  },
                }}
              >
                <ArgonBox display="flex" justifyContent="space-between" alignItems="flex-start">
                  <ArgonBox flex={1}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1} fontSize="0.875rem">
                      {item.text}
                    </ArgonTypography>
                    
                  </ArgonBox>
                  <IconButton
                    size="small"
                    sx={{
                      color: "primary.main",
                      ml: 1,
                      "&:hover": {
                        backgroundColor: "rgba(243, 100, 33, 0.1)",
                      },
                    }}
                  >
                    <DeleteIcon onClick={handleDeleteClick1} fontSize="small" color='error' />
                  </IconButton>
                </ArgonBox>
              </Card>
            ))
          )}
        </ArgonBox>


      </Card>
    </Grid>
     
     <MiniDialog
      open={open}
      onClose={handleClose}
      title="Add Complaint"
      label="Complaint"
      placeholder="Enter complaint"
    />
     <MiniDialog
      open={open1}
      onClose={handleClose1}
      title="Add Feedback"
      label="Feedback"
      placeholder="Enter feedback"
    />

  </Grid>

  {/* Deletedialog */}
  <DeleteDialog
    open={deleteDialog}
    onClose={handleDeleteClose}
    onConfirm={handleDeleteClose}
    title="Delete Complaint"
    description="Are you sure you want to delete?"
    confirmText="Delete"
    cancelText="Cancel"
  />
  

  <DeleteDialog
    open={deleteDialog1}
    onClose={handleDeleteClose1}
    onConfirm={handleDeleteClose1}
    title="Delete Feedback"
    description="Are you sure you want to delete?"
    confirmText="Delete"
    cancelText="Cancel"
  />


</ArgonBox>

  )
}

export default communication